<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { basicSetup, minimalSetup } from "codemirror";
  import { EditorView, keymap } from "@codemirror/view"
  import { indentWithTab } from "@codemirror/commands"
  import { foldGutter } from '@codemirror/language';
  import { EditorState, Compartment } from "@codemirror/state";
  import { python } from '@codemirror/lang-python';
  import { javascript } from '@codemirror/lang-javascript';

  export let language = 'js';
  export let data = '';
  export let readOnly = false;
  export let color = '#333';
  export let backgroundColor = '#eee2';
  export let keyboardShortcuts = {};

  export let editor = undefined;
  let editorArea;
  let readOnlyCompartment = new Compartment;
  let languageCompartment = new Compartment;
  let lastLanguage;

  // const dispatch = createEventDispatcher();
  function createKeymap(key, action) {

    return keymap.of([{
      key,
      run() { action(); return true }
    }])
  }


  const updateDoc = EditorState.transactionExtender.of(tr => {
    if (tr?.changes?.inserted?.length || tr?.changes?.sections?.length > 2 || (tr?.changes?.sections?.length == 2 && tr.changes.sections[1] == 0)) {
      setTimeout(() => {
        data = editor.state.doc?.text?.join('\n') || editor.state.doc?.children?.map(c => c?.text?.join('\n') || '').join('\n') || '';
        // console.log(data);
      }, 100)

    } else {
      // console.log(tr?.changes?.sections );
    }

    // dispatch('update')

  })


  $: {
    if (editor && language != lastLanguage) {
      editor.dispatch({
        effects: [
          languageCompartment.reconfigure(language === 'json' || language === 'js' || language === 'javascript' ? javascript() : python())
        ]
      })
      lastLanguage = language;
    }
    if (editor && data != (editor.state.doc?.text?.join('\n') || editor.state.doc?.children?.map(c => c?.text?.join('\n') || '').join('\n') || '')) {
      // console.log(data, editor.state.doc?.text?.join('\n') || editor.state.doc?.children?.map(c => c?.text?.join('\n') || '').join('\n') || '')

      editor.dispatch({changes: [{
        from: 0,
        to: editor.state.doc.length, 
        insert: data
      }]}) 

    }

  }
  let theme = EditorView.theme({
    '.cm-content': {
      backgroundColor: backgroundColor,
      color: color,
    }, 
    '.cm-scroller': {
      'border-radius': '5px',
    },
    '&.cm-editor': {
      'border-radius': '5px',
    }, 
    '&.cm-editor.cm-focused': {
      outline: readOnly ? 'none': '1px solid var(--primary)',
    },
    "&.cm-focused .cm-cursor": {
      borderLeftColor: readOnly ? "transparent" : '#333',
    },
    '.cm-activeLineGutter': {
      'background-color': '#1adbab10',
    },
    '.cm-activeLine': {
      'background-color': readOnly? 'transparent' : '#1adbab10',
    },
  })
  onMount(() => {
    editor = new EditorView({
      doc: data,
      extensions: [
        ...Object.entries(keyboardShortcuts).map(([key, action]) => createKeymap(key, action)),
        readOnly ? minimalSetup : basicSetup,
        theme,
        keymap.of([indentWithTab]),
        languageCompartment.of(language === 'json' || language === 'js' || language === 'javascript' ? javascript() : python()),
        readOnlyCompartment.of(EditorState.readOnly.of(readOnly)),
        updateDoc,
        ...(readOnly ? [foldGutter()] : [])
      ],
      parent: editorArea
    })


  })

</script>

<div bind:this={editorArea} style={`--editor-background: ${backgroundColor}`}/>

<style>
  div {
    text-align: left;
  }
  
</style>
